export var QueryName;
(function (QueryName) {
    QueryName["GET_DEALS"] = "GetDeals";
    QueryName["GET_DEAL"] = "GetDeal";
})(QueryName || (QueryName = {}));
//# sourceMappingURL=QueryName.js.map